import { Users } from '@platform/client';
import { useLocation } from 'wouter';
import EVENTS from '../analytics/events';
import dataTestids from '../constants/test-ids';
import { ROUTES } from '../routes/consts';
import NavbarDropdown, { NavbarDropdownItem } from './NavbarDropdown';

/** Shows user-level nav links in the Dashboard */
const ProfileDropdown = () => {
  const userData = Users.useGetCurrentUser();

  const location = useLocation();
  const currentRoute = location[0];

  const logoutHref = import.meta.env.VITE_API_HOST + '/login/logout';

  const menuItems: NavbarDropdownItem[] = [
    {
      title: 'Home',
      href: ROUTES.DASHBOARD,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.HOME_CLICKED,
      // Currently our nested routing matches '/' here when on the dashboard home page.
      active: currentRoute === '/',
    },
    {
      title: 'Account and Profile',
      href: `${ROUTES.DASHBOARD}${ROUTES.ACCOUNT}`,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.ACCOUNT_AND_PROFILE_CLICKED,
    },
    {
      title: 'Logout',
      href: logoutHref,
      linkType: 'external',
      newTab: false,
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.LOGOUT_CLICKED,
    },
  ];

  return (
    <NavbarDropdown
      avatar={userData.data?.avatar || ''}
      avatarFallbackIcon='user-01'
      buttonText={userData?.data ? `${userData.data.firstName} ${userData.data.lastName}` : ''}
      isLoading={!userData.isSuccess}
      items={menuItems}
      dataTestId={dataTestids.LAYOUT.PROFILE_DROPDOWN}
    />
  );
};

export default ProfileDropdown;
